import styles from "./MainLayout.module.css";

/* Main application window shell */
export function MainLayout({ children }) {
  return <div className={styles.shell}>{children}</div>;
}
